import { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";

import MuiAlert from "@material-ui/lab/Alert";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import update from "immutability-helper";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import ProductionOrderService from "../../../../services/Production/ProductionOrderService";
import UtilsFormule from "../../../../utils/UtilsFormule";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const PopupExecutionProducts = ({
  setAvancementBtn,
  setOnAddPopupExecution,
  setDechets,
  setBom,
  setWorkOrder,
  dechets,
  workOrder,
  reset,
  startDate,
  setStartDate,
}) => {
  console.log("dechets", dechets);
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const animatedComponents = makeAnimated();

  const [listDechets, setListDechets] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [dechetId, setDechetId] = useState(null);
  const [quantityDemande, setQuantityDemande] = useState(0);
  const [quantityGenere, setQuantityGenere] = useState(0);
  const [quantity, setQuantity] = useState();
  const [quantityProduct, setQuantityProduct] = useState();
  const [unity, setUnity] = useState();
  const [quantityEnStock, setQuantityEnStock] = useState();
  const [nbrProduct, setNbrProduct] = useState(0);

  const [dechetSelectPlaceHolder, setDechetSelectPlaceHolder] =
    useState("Choisir...");
  const [productTableData, setProductTableData] = useState([]);

  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    console.log(dechets);
    dechets &&
      dechets.map((element) => {
        setListDechets((oldArray) => [
          ...oldArray,
          {
            value: element.assemblyComponentDecheWorkOrder.id,
            label: element.assemblyComponentDecheWorkOrder.product.name,
            customElements: {
              quantityDemande:
                element.assemblyComponentDecheWorkOrder.quantityDemande,
              quantityGenere:
                element.assemblyComponentDecheWorkOrder.quantityConsomme,
              unityCode:
                element.assemblyComponentDecheWorkOrder.unitOfMeasure.code,
              quantityEnStock: element.quantityInStock,
            },
          },
        ]);
      });
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeQuantity = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeQuantityProduct = (event) => {
    setQuantityProduct(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnAddPopupExecution(false);
    setAvancementBtn(false);
  };

  const updateWorkOrdersComponents = () => {
    setEndDate();

    setAvancementBtn(false);
    let finalProductValue = {
      id: workOrder.product.id,
      quantity: quantity,
    };
    let model = {
      idUser: getCurrentUserId(),
      idWorkOrder: workOrder.id,
      finalProductValue: finalProductValue,
      dechetValues: productTableData,
      nbrDechet:nbrProduct,

      startDate: startDate,
      endDate: UtilsFormule.formatDateForBackend(new Date()),
      workOrderType: "WORK",

    };

    ProductionOrderService.updateWorkOrdersComponents(model)
      .then((response) => {
        console.log("getWorkOrderById", response.data.success);
        setWorkOrder(response.data.success);
        setBom(response.data.bom);
        setDechets(response.data.dechet);
        setOpen(false);
        setOnAddPopupExecution(false);
        setAvancementBtn(false);
        setStartDate();
        reset();
      })
      .catch((e) => {
        alert("problème de connexion");
      });
  };

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  const onChangeSelectedDechet = (selectedOptionn) => {
    setSelectedOption();
    setDechetId(selectedOptionn.value);
    setDechetSelectPlaceHolder(selectedOptionn.label);
    setQuantityDemande(selectedOptionn.customElements.quantityDemande);
    setQuantityGenere(selectedOptionn.customElements.quantityGenere);
    setUnity(selectedOptionn.customElements.unityCode);
    setQuantityEnStock(selectedOptionn.customElements.quantityEnStock);
  };

  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productTableData.forEach((element, index) => {
        console.log("element", element);
        if (element.id === dechetId) {
          indexInDataTable = index;
          productRef = element.productRef;
          exist = true;
          console.log("productMapById indexInDataTable", indexInDataTable);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      listDechets.forEach((element) => {
        if (element.value === dechetId) {
          productRef = element.label;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    if (dechetId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Sélectionnez un produit ");
    } else {
      if (!exist) {
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            id: dechetId,
            quantity: quantityProduct,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.quantity = quantityProduct;
        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        setOpenInfoAlert(true);
        setInfoAlertText(
          "Info : Vous avez actualisé la quantité produit :  " + productRef
        );
        setProductTableData(modelData);
      }
    }
  };

  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
      const onChangeNbrProduct = (event) => {
    setNbrProduct(event.target.value);
  };
  return (
    <>
      <div class="modal fade" id="execution-production">
        <div class="modal-dialog modal-xl ">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Pointage Produit Fini et déchets</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">
                      Produit : {workOrder.product.productCode}-
                      {workOrder.product.barcode}-{workOrder.product.name}
                    </label>
                    <br />
                    <label htmlFor="inputName">
                      Quantité demandée : {workOrder.quantity}{" "}
                      {workOrder.billOfMaterials.unitOfMeasure.code}
                    </label>
                    <br />
                    <label htmlFor="inputName">
                      Quantité Produite : {workOrder.quantityProduite}{" "}
                      {workOrder.billOfMaterials.unitOfMeasure.code}
                    </label>

                    <input
                      placeholder="Saisir la nouvelle quantité"
                      onChange={onChangeQuantity}
                      type="number"
                      min="0"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
               <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">
                      Produit deffectué :
                    </label>
                    <br />
                    <label htmlFor="inputName">
                      Quantité Dechet : {workOrder.quantityProduiteDechet}{" "}
                      {workOrder.billOfMaterials.unitOfMeasure.code}
                    </label>

                    <input
                      placeholder="Saisir la nouvelle quantité"
                      onChange={onChangeNbrProduct}
                      type="number"
                      min="0"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-sm-6">
                  <label htmlFor="inputName">Les déchets</label>

                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedDechet}
                    options={listDechets}
                    placeholder={dechetSelectPlaceHolder}
                  />
                </div>
                <div className="form-group col-sm-6">
                  <label htmlFor="inputName">
                    quantité demandé : {quantityDemande}-quantité généré :{" "}
                    {quantityGenere} - quantité en stock : {quantityEnStock}{" "}
                    {unity}
                  </label>
                  <input
                    placeholder="Saisir la nouvelle quantité"
                    onChange={onChangeQuantityProduct}
                    type="number"
                    min="0"
                    id="inputName"
                    className="form-control"
                  />
                </div>
              </div>
              <div class="row">
                <div className="col-sm-12  text-center">
                  <button
                    style={{ marginBottom: 20 }}
                    className="btn btn-dark"
                    onClick={onAddProductToList}
                  >
                    <i class="fas fa-plus"></i>
                    Liste des déchets{" "}
                  </button>
                </div>
              </div>
              <div class="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    {productTableData && (
                      <ToolkitProvider
                        keyField="idProduct"
                        data={productTableData}
                        columns={columnsWithDelete}
                        onTableChange={handleTableChange}
                      >
                        {(props) => (
                          <div>
                            <div className="row">
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={updateWorkOrdersComponents}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <Snackbar
          open={openAlert}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleClose} severity="success">
            Ajout avec success !
          </Alert>
        </Snackbar>
      )}
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default PopupExecutionProducts;
